import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import isEmpty from "lodash/isEmpty"

import history from "app/history"
import { amountFormatter } from "helpers/util"
import PageContainer from "components/common/PageContainer"
import Button from "components/common/Button"

import { fetchCourseById, getTransactionDetails } from "store/courses/action"
import { showResponseModal, closeResponseModal } from "store/user/actions"

import "./index.scss"

import HeroHeader from "components/hero-header/index"

const baseUrl = process.env.PUBLIC_URL
class Instruction extends Component {
  componentDidMount() {
    const {
      location: { pathname },
      getTransactionDetails,
    } = this.props

    let currentPath = pathname.split("/")
    if (
      currentPath[1] === "course" &&
      currentPath[2] === "payment" &&
      !isEmpty(currentPath[3])
    ) {
      let id = currentPath[3].split(/[\s-]+/).pop()
      // fetchCourseById(id)
      console.log("------", id)
      getTransactionDetails(id)
    }
  }

  render() {
    const {
      school: { schoolData },
      courses: {
        selectedCourse,
        isLoadingSelectedCourse,
        paymentInstruction: { data },
      },
    } = this.props

    const currentPath = `/course/payment/${selectedCourse?.slug}`
    const routeList = {
      "/": "Home",
      "/courses": "Course",
      [currentPath]: "Payment",
      "/Instruction": "Instruction",
    }

    return (
      <PageContainer isPageLoading={isLoadingSelectedCourse}>
        <HeroHeader
          title="Course Payment Instruction"
          description=""
          routeList={routeList}
          activeColor={schoolData.primary_color}
          activeItem="Instruction"
        />
        <div className="page-wrapper -instruction">
          <div className="header-container">
            <div className="header">
              <>
                <div className="title">{data?.channel}</div>
                <div className="subtitle">
                  {`Present the barcode below to the cashier at any ${data?.channel} branches nationwide.`}
                </div>
              </>
            </div>
          </div>
          <div className="payment-card">
            <div className="header">
              <div className="header-content">
                <img
                  key={data?.channel}
                  alt="logo"
                  src={`${baseUrl}/static/partners-logo/${data?.channel}.png`}
                  className="channel-icon"
                />
              </div>
              <div className={`status ${data?.status?.toLowerCase()}`}>
                <p>{data?.status}</p>
              </div>
            </div>
          </div>
          <div className="payment-content">
            <div className="reference">
              <img
                key={data?.id}
                alt="barcode"
                src={data?.image_url}
                className="barcode"
              />
              <div className="barcode-text">{data?.ref_code}</div>
            </div>
            <div className="payment-details">
              <div className="section-label">Payment Details</div>
            </div>

            <div className="details-container">
              <div className="label">Reference No.:</div>
              <div className="text">{data?.ref_code}</div>
            </div>

            <div className="details-container">
              <div className="label">Merchant Name:</div>
              <div className="text">{data?.seller_name}</div>
            </div>

            <div className="details-container">
              <div className="label">Issuance Date:</div>
              <div className="text">{data?.created}</div>
            </div>

            <div className="details-container">
              <div className="label">Expiry Date:</div>
              <div className="text">{data?.expiry}</div>
            </div>
            <div className="details-container">
              <div className="label">Amount to Pay:</div>
              <div className="text">PHP {amountFormatter(data?.amount)}</div>
            </div>

            <div className="payment-details">
              <div className="section-label">Instructions</div>
            </div>
            {data?.instructions?.Payment.map((data, i) => {
              return (
                <div className="instruction-container">
                  <div className="label">{`${i + 1}.`}</div>
                  <div className="text">{data}</div>
                </div>
              )
            })}
          </div>
          <div className="payment-footer">
            {`Disclaimer: By using ${data?.channel}, you agree to its `}
            <Button
              ghost
              label="Terms and Conditions"
              onClick={() => window.open(data?.terms)}
            />
          </div>
          <Button
            outlined
            label="GO TO COURSES DASHBOARD"
            onClick={() => history.push(`/courses/`)}
          />
        </div>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state) => ({
  courses: state.coursesReducer,
  user: state.userReducer,
  auth: state.authReducer,
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchCourseById,
      showResponseModal,
      closeResponseModal,
      getTransactionDetails,
    },
    dispatch
  )

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(Instruction)
